<div class="reports-page">
  <div class="reports-heading">{{ title }}</div>

  <div *ngIf="isLoading" class="state-message">Loading…</div>

  <ng-container *ngIf="!isLoading">
    <!-- One card per item from the dummy API. -->
    <div *ngIf="cards.length > 0" class="reports-grid">
      <div
        class="report-card"
        *ngFor="let card of cards; trackBy: trackByCard; let i = index"
        [class.disabled]="card.disabled"
        [style.animation-delay.ms]="i * 60"
        role="button"
        tabindex="0"
        (click)="onCardClick(card)"
        (keydown)="onCardKeydown($event, card)">
        <span class="icon-halo">
          <mat-icon class="report-icon">{{ iconFor(card) }}</mat-icon>
        </span>
        <div class="report-title">{{ card.title }}</div>
      </div>
    </div>

    <!-- Empty state — broken-puzzle glyph + message. -->
    <div *ngIf="cards.length === 0" class="empty-state">
      <div class="empty-text">No reports to display</div>
      <mat-icon class="empty-icon">extension_off</mat-icon>
    </div>
  </ng-container>
</div>
